"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from "../../lib/utils";
function Skeleton({ className, children, ...props }) {
    return (_jsx("div", { className: cn("stack-scope animate-pulse rounded-md bg-primary/10", className), ...props, children: _jsx("div", { className: "invisible inline", children: children }) }));
}
export { Skeleton };
